var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel5BadgeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 906,
    height: 755,
    viewBox: "0 0 906 755",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 906,
    height: 755,
    rx: 32,
    fill: "url(#paint0_radial_7084_2995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7084_2995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(453 377.5) rotate(90) scale(377.5 453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69EC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#068B05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5BadgeBg);
export default __webpack_public_path__ + "static/media/Level5BadgeBg.505c62adaab6531665f06f5fb218c31b.svg";
export { ForwardRef as ReactComponent };